import { FormFieldHelperText } from '@ipfabric/ui-components/FormFieldHelperText/FormFieldHelperText';
import {
  FormSelect,
  type FormSelectProps,
} from '@ipfabric/ui-components/FormSelect/FormSelect';
import { useMemo } from 'react';
import type { FieldValues } from 'react-hook-form';
import { useWatch } from 'react-hook-form';

type Props<TFieldValues extends FieldValues> = {
  control: FormSelectProps<TFieldValues>['control'];
  name: FormSelectProps<TFieldValues>['name'];
  label: string;
  options: { value: string; label: string }[];
  emptyOptionsHint?: string;
};

export const AimEntityCombobox = <TFieldValues extends FieldValues>(
  props: Props<TFieldValues>,
) => {
  const currentValue = useWatch({
    control: props.control,
    name: props.name,
  }) as string | null;

  const isOrphan =
    currentValue !== null &&
    currentValue !== undefined &&
    currentValue !== '' &&
    !props.options.some((o) => o.value === currentValue);

  const optionsWithOrphanFallback = useMemo(
    () =>
      isOrphan
        ? [
            {
              value: currentValue,
              label: `⚠ Missing reference: ${currentValue}`,
              disabled: true,
            },
            ...props.options,
          ]
        : props.options,
    [isOrphan, currentValue, props.options],
  );

  return (
    <>
      <FormSelect.Optional
        control={props.control}
        name={props.name}
        label={props.label}
        options={optionsWithOrphanFallback}
      />
      {props.options.length === 0 && props.emptyOptionsHint && (
        <FormFieldHelperText>{props.emptyOptionsHint}</FormFieldHelperText>
      )}
    </>
  );
};
